// @flow
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FadeInUp, FadeIn } from 'animate-css-styled-components';

import { WarningIcon } from 'icons';

import theme from 'utils/theme';

export default function FieldComponent({
    children,
    group,
    label,
    empty,
    error,
    errorMessage = 'Invalid information',
    ...props
}) {
    if (group) return <FieldGroup {...props}>{children}</FieldGroup>;

    return (
        <Fragment>
            <Field id="field-wrapper" hasError={error} {...props}>
                {empty ? (
                    <Empty />
                ) : (
                    <span id="field-label">
                        <FadeInUp>{label}</FadeInUp>
                    </span>
                )}
                {children}
                {error && (
                    <ErrorFeedback data-test="field-error" id="field-error">
                        <FadeIn>
                            <WarningIcon name="attention-error" /> {errorMessage}
                        </FadeIn>
                    </ErrorFeedback>
                )}
            </Field>
        </Fragment>
    );
}

const FieldGroup = styled.div`
    -webkit-justify-content: space-between;
    display: flex;
    justify-content: space-between;
    height: 55px;
    margin-bottom: -15px;

    div {
        width: 45%;
        margin-top: 0;
        margin-bottom: 0;

        div {
            width: 100%;
        }
    }
`;

const Field = styled.div`
    font-size: 13px;
    margin: 3rem 0;

    span {
        font-size: 10px;
        position: relative;
        float: left;
        top: -5px;
        color: ${({ hasError }) => (hasError ? theme.colors.error500 : theme.colors.grey300)};
    }

    label {
        display: block;
        margin-bottom: 0.2rem;
        border-bottom: ${() => `1px solid ${theme.colors.grey300}`};
        color: ${() => theme.colors.grey300};
        text-align: left;
    }

    input,
    textarea,
    select {
        width: 100%;
        color: ${({ hasError }) => (hasError ? theme.colors.error500 : theme.colors.black)};

        ::placeholder {
            color: ${() => theme.colors.grey300};
        }
    }
`;

const Empty = styled.div`
    height: 7px;
`;

const ErrorFeedback = styled.div`
    color: ${() => theme.colors.error500};
    text-align: left;
    position: relative;
    float: left;
`;
